module.exports = __webpack_public_path__ + "img/medal6.a03542eb.png";